import { render } from "./ExportForBlender.vue?vue&type=template&id=96b7a698&scoped=true"
import script from "./ExportForBlender.vue?vue&type=script&lang=js"
export * from "./ExportForBlender.vue?vue&type=script&lang=js"

import "./ExportForBlender.vue?vue&type=style&index=0&id=96b7a698&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96b7a698"]])

export default __exports__